import React from 'react';
import {
  Layout,
  Card,
  Button,
  Row,
  Col,
  Typography,
  Space,
  Divider,
  Tag,
  Statistic,
  Carousel
} from 'antd';
import {
  DashboardOutlined,
  FileWordOutlined,
  SafetyCertificateOutlined,
  CheckCircleOutlined,
  ThunderboltOutlined,
  TeamOutlined,
  ApiOutlined,
  MailOutlined,
  RightOutlined
} from '@ant-design/icons';
import './HomePage.css';
import logo from './logo.jpg';
import beianIcon from './beian.png';

const { Header, Content, Footer } = Layout;
const { Title, Paragraph, Text } = Typography;

const HomePage = () => {
  // 系统卡片配置
  const systems = [
    {
      key: 'quota',
      title: '智能定额匹配',
      subtitle: 'AI驱动 · 精准高效',
      icon: <ApiOutlined style={{ fontSize: 48, color: '#1890ff' }} />,
      description:
        '基于深度学习技术，自动解析工程量清单Excel，智能匹配最合适的定额子目。支持建筑装饰、安装、市政等多专业，平均节省造价人员70%以上查找时间。',
      features: [
        'Excel智能解析',
        'AI定额匹配',
        '多专业支持(河北2022/2023定额)',
        '一键导出计价软件格式'
      ],
      url: 'https://quota.concos.cn',
      buttonText: '进入定额匹配',
      gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      tags: ['推荐', '热门']
    },
    {
      key: 'doc',
      title: '智能文档生成',
      subtitle: 'DeepSeek驱动 · 一键生成',
      icon: <FileWordOutlined style={{ fontSize: 48, color: '#52c41a' }} />,
      description:
        '通过大语言模型快速生成Word、Excel、PPT等多格式文档。提供商务、学术、报告等数十种模板，大幅提升文档撰写效率，让您专注于内容本身。',
      features: [
        'Word/Excel/PPT生成',
        '多种专业模板',
        '智能内容填充',
        '在线预览与下载'
      ],
      url: 'https://doc.concos.cn',
      buttonText: '进入文档生成',
      gradient: 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)',
      tags: ['新上线']
    },
    {
      key: 'bidding',
      title: '智能清标分析',
      subtitle: '多模式 · 全维度',
      icon: <SafetyCertificateOutlined style={{ fontSize: 48, color: '#faad14' }} />,
      description:
        '支持自主报价、清单报价、控制价偏差分析三种模式，自动检测不平衡报价、单价异常、工程量偏差，识别围串标风险，输出专业清标报告。',
      features: [
        '三种清标模式',
        '不平衡报价检测',
        '围串标风险分析',
        '一键导出Excel报告'
      ],
      url: 'https://qingbiao.concos.cn',
      buttonText: '进入清标系统',
      gradient: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
      tags: ['专业']
    }
  ];

  return (
    <Layout className="home-layout">
      {/* 头部导航 */}
      <Header
        className="home-header"
        style={{
          background: '#fff',
          boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
          display: 'flex',
          justifyContent: 'center',
          zIndex: 10
        }}
      >
        <div
          className="header-content"
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
            maxWidth: 1200
          }}
        >
          <div className="logo" style={{ display: 'flex', alignItems: 'center' }}>
            <img
              src={logo}
              alt="造价快车"
              style={{ height: 40, marginRight: 12 }}
            />
            <span className="logo-text">造价快车</span>
          </div>
          <div className="nav-links" style={{ display: 'flex', justifyContent: 'center', flex: 1 }}>
            <Button type="link" size="large">
              首页
            </Button>
            <Button type="link" size="large" onClick={() => window.open('https://quota.concos.cn', '_self')}>
              定额匹配
            </Button>
            <Button type="link" size="large" onClick={() => window.open('https://doc.concos.cn', '_self')}>
              文档生成
            </Button>
            <Button type="link" size="large" onClick={() => window.open('https://qingbiao.concos.cn', '_self')}>
              清标分析
            </Button>
          </div>
          <div className="auth-buttons">
            <Space>
              <Button
                type="primary"
                ghost
                onClick={() => window.open('https://quota.concos.cn/login', '_self')}
              >
                登录
              </Button>
              <Button
                type="primary"
                onClick={() => window.open('https://quota.concos.cn/register', '_self')}
              >
                免费注册
              </Button>
            </Space>
          </div>
        </div>
      </Header>

      {/* 主内容 */}
      <Content style={{ background: '#f0f2f5' }}>
        {/* 英雄区域 */}
        <section
          className="hero-section"
          style={{
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            padding: '80px 24px',
            textAlign: 'center',
            color: '#fff'
          }}
        >
          <Title
            level={1}
            style={{
              color: '#fff',
              fontSize: 48,
              marginBottom: 16,
              fontWeight: 700
            }}
          >
            建设工程智能解决方案
          </Title>
          <Paragraph
            style={{
              color: 'rgba(255,255,255,0.85)',
              fontSize: 18,
              maxWidth: 700,
              margin: '0 auto 32px'
            }}
          >
            融合AI与大语言模型技术，提供定额匹配、文档生成、清标分析三大核心服务，
            助力造价行业数字化转型，让工作更智能、更高效
          </Paragraph>
          <Space size="large">
            <Button
              type="primary"
              size="large"
              style={{
                background: '#fff',
                color: '#667eea',
                border: 'none',
                fontWeight: 600
              }}
              onClick={() => document.getElementById('systems')?.scrollIntoView({ behavior: 'smooth' })}
            >
              了解全部产品
            </Button>
            <Button
              ghost
              size="large"
              style={{ color: '#fff', borderColor: '#fff' }}
              onClick={() => window.open('https://quota.concos.cn/register', '_self')}
            >
              立即注册体验
            </Button>
          </Space>
        </section>

        {/* 数据亮点 */}
        <section style={{ padding: '60px 24px', background: '#fff' }}>
          <Row gutter={[32, 32]} justify="center">
            <Col xs={24} sm={8}>
              <div style={{ textAlign: 'center' }}>
                <Statistic
                  title="累计处理项目"
                  value={1580}
                  suffix="+"
                  prefix={<CheckCircleOutlined />}
                  valueStyle={{ color: '#1890ff' }}
                />
              </div>
            </Col>
            <Col xs={24} sm={8}>
              <div style={{ textAlign: 'center' }}>
                <Statistic
                  title="平均效率提升"
                  value={70}
                  suffix="%"
                  prefix={<ThunderboltOutlined />}
                  valueStyle={{ color: '#52c41a' }}
                />
              </div>
            </Col>
            <Col xs={24} sm={8}>
              <div style={{ textAlign: 'center' }}>
                <Statistic
                  title="服务用户数"
                  value={3200}
                  prefix={<TeamOutlined />}
                  valueStyle={{ color: '#722ed1' }}
                />
              </div>
            </Col>
          </Row>
        </section>

        {/* 三大系统详细介绍 */}
        <section id="systems" style={{ padding: '80px 24px' }}>
          <div style={{ textAlign: 'center', marginBottom: 48 }}>
            <Title level={2} style={{ marginBottom: 8 }}>
              三大核心产品
            </Title>
            <Paragraph type="secondary" style={{ fontSize: 16 }}>
              覆盖造价工作的关键环节，一站式解决您的需求
            </Paragraph>
          </div>

          <Row gutter={[32, 32]} justify="center">
            {systems.map((sys) => (
              <Col xs={24} md={8} key={sys.key}>
                <Card
                  hoverable
                  style={{
                    borderRadius: 12,
                    overflow: 'hidden',
                    height: '100%',
                    transition: 'transform 0.3s'
                  }}
                  bodyStyle={{ padding: '32px 24px' }}
                >
                  <div style={{ textAlign: 'center', marginBottom: 24 }}>
                    {sys.icon}
                    <Title level={3} style={{ marginTop: 16, marginBottom: 4 }}>
                      {sys.title}
                    </Title>
                    <Text type="secondary" style={{ fontSize: 14 }}>
                      {sys.subtitle}
                    </Text>
                  </div>

                  <Paragraph style={{ minHeight: 80, marginBottom: 16 }}>
                    {sys.description}
                  </Paragraph>

                  <div style={{ marginBottom: 24 }}>
                    {sys.features.map((feat) => (
                      <Tag
                        key={feat}
                        color="blue"
                        style={{ marginBottom: 8, fontSize: 12 }}
                      >
                        {feat}
                      </Tag>
                    ))}
                  </div>

                  <Button
                    type="primary"
                    block
                    size="large"
                    icon={<RightOutlined />}
                    onClick={() => window.open(sys.url, '_self')}
                    style={{
                      background: sys.gradient,
                      border: 'none',
                      fontWeight: 500,
                      height: 44
                    }}
                  >
                    {sys.buttonText}
                  </Button>
                </Card>
              </Col>
            ))}
          </Row>
        </section>

        {/* 使用流程 */}
        <section style={{ padding: '80px 24px', background: '#fff' }}>
          <div style={{ textAlign: 'center', marginBottom: 48 }}>
            <Title level={2}>如何开始使用？</Title>
            <Paragraph type="secondary" style={{ fontSize: 16 }}>
              简单三步，即刻体验智能造价工具
            </Paragraph>
          </div>
          <Row gutter={[48, 48]} justify="center">
            <Col xs={24} md={8}>
              <Card style={{ textAlign: 'center' }}>
                <div
                  style={{
                    width: 60,
                    height: 60,
                    borderRadius: '50%',
                    background: '#e6f7ff',
                    color: '#1890ff',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: 24,
                    fontWeight: 'bold',
                    margin: '0 auto 20px'
                  }}
                >
                  1
                </div>
                <Title level={4}>注册账号</Title>
                <Paragraph type="secondary">
                  使用邮箱注册造价快车平台账号，即可获得免费试用额度
                </Paragraph>
              </Card>
            </Col>
            <Col xs={24} md={8}>
              <Card style={{ textAlign: 'center' }}>
                <div
                  style={{
                    width: 60,
                    height: 60,
                    borderRadius: '50%',
                    background: '#f6ffed',
                    color: '#52c41a',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: 24,
                    fontWeight: 'bold',
                    margin: '0 auto 20px'
                  }}
                >
                  2
                </div>
                <Title level={4}>选择服务</Title>
                <Paragraph type="secondary">
                  根据需求进入定额匹配、文档生成或清标分析对应的子系统
                </Paragraph>
              </Card>
            </Col>
            <Col xs={24} md={8}>
              <Card style={{ textAlign: 'center' }}>
                <div
                  style={{
                    width: 60,
                    height: 60,
                    borderRadius: '50%',
                    background: '#fff7e6',
                    color: '#faad14',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: 24,
                    fontWeight: 'bold',
                    margin: '0 auto 20px'
                  }}
                >
                  3
                </div>
                <Title level={4}>上传文件/输入需求</Title>
                <Paragraph type="secondary">
                  上传工程量清单、输入文档要求或上传清标文件，AI自动处理并返回结果
                </Paragraph>
              </Card>
            </Col>
          </Row>
        </section>

        {/* 底部CTA */}
        <section
          style={{
            padding: '80px 24px',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            textAlign: 'center',
            color: '#fff'
          }}
        >
          <Title level={2} style={{ color: '#fff', marginBottom: 16 }}>
            立即开启智能造价之旅
          </Title>
          <Paragraph style={{ color: 'rgba(255,255,255,0.85)', fontSize: 16, maxWidth: 600, margin: '0 auto 32px' }}>
            注册即享免费额度，无需下载安装，浏览器打开直接使用
          </Paragraph>
          <Button
            type="primary"
            size="large"
            style={{
              background: '#fff',
              color: '#667eea',
              border: 'none',
              fontWeight: 600,
              height: 48,
              padding: '0 48px'
            }}
            onClick={() => window.open('https://quota.concos.cn/register', '_self')}
          >
            免费注册
          </Button>
        </section>
      </Content>

      {/* 页脚 */}
      <Footer style={{ background: '#001529', color: 'rgba(255,255,255,0.65)', padding: '40px 24px 20px' }}>
        <div style={{ maxWidth: 1200, margin: '0 auto', textAlign: 'center' }}>
          <Row gutter={[32, 32]} justify="center">
            <Col xs={24} sm={8}>
              <Title level={4} style={{ color: '#fff' }}>
                造价快车
              </Title>
              <Paragraph style={{ color: 'rgba(255,255,255,0.65)' }}>
                建设工程定额智能匹配平台
                <br />
                智能文档生成与清标分析服务
              </Paragraph>
            </Col>
            <Col xs={24} sm={8}>
              <Title level={4} style={{ color: '#fff' }}>
                产品链接
              </Title>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                <a
                  href="https://quota.concos.cn"
                  target="_self"
                  style={{ color: 'rgba(255,255,255,0.65)' }}
                >
                  智能定额匹配
                </a>
                <a
                  href="https://doc.concos.cn"
                  target="_self"
                  style={{ color: 'rgba(255,255,255,0.65)' }}
                >
                  智能文档生成
                </a>
                <a
                  href="https://qingbiao.concos.cn"
                  target="_self"
                  style={{ color: 'rgba(255,255,255,0.65)' }}
                >
                  智能清标分析
                </a>
              </div>
            </Col>
            <Col xs={24} sm={8}>
              <Title level={4} style={{ color: '#fff' }}>
                联系方式
              </Title>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}>
                <MailOutlined />
                <a
                  href="mailto:273771918@qq.com"
                  style={{ color: 'rgba(255,255,255,0.65)' }}
                >
                  273771918@qq.com
                </a>
              </div>
            </Col>
          </Row>
          <Divider style={{ borderColor: 'rgba(255,255,255,0.2)' }} />
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 12,
              fontSize: 14
            }}
          >
            <div style={{ display: 'flex', gap: 20, flexWrap: 'wrap', justifyContent: 'center' }}>
              <a
                href="https://beian.miit.gov.cn"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: 'rgba(255,255,255,0.65)', textDecoration: 'none' }}
              >
                冀ICP备2025132056号-1
              </a>
              <a
                href="https://beian.mps.gov.cn/#/query/webSearch?code=13060202001287"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: 'rgba(255,255,255,0.65)', textDecoration: 'none', display: 'flex', alignItems: 'center', gap: 6 }}
              >
                <img
                  src={beianIcon}
                  alt="公安备案"
                  style={{ width: 16, height: 16 }}
                />
                冀公网安备13060202001287号
              </a>
            </div>
            <Text style={{ color: 'rgba(255,255,255,0.45)' }}>
              造价快车 © 2025 版权所有
            </Text>
          </div>
        </div>
      </Footer>
    </Layout>
  );
};

export default HomePage;